import { restClient } from '@/Core'

/** Вид файлу документа: Word чи PDF. */
export type OfficeFileKind = 'word' | 'pdf'

/** Перегляд чи редагування. Редагувати можна лише Word (`SPEC-012` §7.8). */
export type OfficeViewerMode = 'view' | 'edit'

/** Відповідь `edit_session` (`SPEC-012` §7.6). */
export interface EditSession {
    /** Адреса `cool.html` з `WOPISrc` — на домені тенанта */
    actionUrl: string
    accessToken: string
    /** Мілісекунди від епохи — як чекає Collabora в `access_token_ttl` */
    accessTokenTtl: number
    fileName: string
    canWrite: boolean
}

const isEditSession = (value: unknown): value is EditSession => {
    if (value === null || typeof value !== 'object') return false

    const session = value as Record<string, unknown>

    return (
        typeof session['actionUrl'] === 'string' &&
        typeof session['accessToken'] === 'string' &&
        typeof session['accessTokenTtl'] === 'number' &&
        typeof session['fileName'] === 'string' &&
        typeof session['canWrite'] === 'boolean'
    )
}

/**
 * `POST <sessionUrl>` — `/services/client_documents/{uuid}/edit_session` чи
 * перевізника (`SPEC-012` §7.6). Права (`*_READ` / `*_UPDATE`) перевіряє бек;
 * помилку (403, 404, 422, 503) показує `serverMessage()`.
 */
export const OpenEditSessionTask = async (
    sessionUrl: string,
    kind: OfficeFileKind,
    mode: OfficeViewerMode
): Promise<EditSession> => {
    const response = (await restClient.post(sessionUrl, { json: { kind, mode } })) as unknown

    if (!isEditSession(response)) {
        throw new Error('Редактор документів відповів незрозуміло. Спробуйте ще раз.')
    }

    return response
}
